module.exports = __webpack_public_path__ + "static/media/icon_emoji_smile.90e65129.png";